var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('OccHeading',{staticClass:"section__label",attrs:{"color":"gray","level":3}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"section__input"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }